import { useId, useState } from "react";
import { Copy, MessageCircle, Share2 } from "lucide-react";

export default function PhotoShare({ path, title = "Class photograph" }) {
  const [open, setOpen] = useState(false);
  const [notice, setNotice] = useState("");
  const panelId = useId();
  const url = new URL(path, window.location.origin).href;

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      setNotice("Link copied. Paste it into WhatsApp or a message.");
    } catch {
      setNotice("Select and copy the link below.");
    }
  }

  return (
    <div className="photo-share">
      <button className="button button--small button--cream" type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpen(!open)}>
        <Share2 aria-hidden="true" /> Share this picture
      </button>
      {open && <div className="photo-share__panel" id={panelId}>
        <div className="button-row">
          <a className="button button--small button--ink" href={`https://wa.me/?text=${encodeURIComponent(`${title}\n${url}`)}`} target="_blank" rel="noopener noreferrer"><MessageCircle aria-hidden="true" /> WhatsApp</a>
          <button className="button button--small button--ghost" type="button" onClick={copyLink}><Copy aria-hidden="true" /> Copy link</button>
        </div>
        <label>Picture link<input readOnly value={url} onFocus={(event) => event.target.select()} /></label>
        <small>Opens this picture in its album. Member sign-in is required.</small>
        <p role="status">{notice}</p>
      </div>}
    </div>
  );
}
